import React from 'react';
import { Page } from '../Page';
import { AlertTriangle } from 'lucide-react';
import { SupplementCallout } from '../SupplementCallout';
export function Page3() {
  return <Page pageNumber={9} variant="light" data-id="element-394">
      <div className="flex flex-col h-full" data-id="element-395">
        <div className="h-[160px] -mx-12 -mt-10 mb-8 overflow-hidden relative" data-id="element-396">
          <img src="https://images.unsplash.com/photo-1532550907401-a500c9a57435?w=1000&q=80" alt="Grilled chicken and protein foods" className="w-full h-full object-cover object-center" data-id="element-397" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#F5F5F0] via-transparent to-transparent" data-id="element-398" />
        </div>

        <div className="mb-8" data-id="element-399">
          <p className="text-[10px] font-bold text-tealslate uppercase tracking-[0.2em] mb-3" data-id="element-400">
            The Essentials
          </p>
          <h1 className="text-5xl font-serif text-[#1F1F1F] leading-tight mb-4" data-id="element-401">
            <span className="text-tealslate" data-id="element-402">Protein</span>
          </h1>
          <div className="w-16 h-0.5 bg-tealslate" data-id="element-403" />
        </div>

        <div className="grid grid-cols-2 gap-10 mb-8" data-id="element-404">
          <div data-id="element-405">
            <p className="text-sm text-[#3B3B3B] leading-[1.8] mb-6" data-id="element-406">
              GLP-1 medications cause rapid weight loss. Without adequate
              protein, a significant portion of that weight loss comes from
              muscle, not just fat. Protein preserves your muscle mass, keeps
              you feeling full, and supports recovery.
            </p>
            <div className="bg-tealslate/10 border border-tealslate/30 p-4" data-id="element-407">
              <h3 className="text-[10px] font-bold text-tealslate uppercase tracking-wider mb-2" data-id="element-408">
                Experienced Lifters
              </h3>
              <p className="text-[#1F1F1F] font-bold text-sm mb-1" data-id="element-409">
                0.7 to 1g per pound of bodyweight per day
              </p>
              <div className="flex gap-2 mt-2" data-id="element-410">
                <span className="bg-tealslate/20 px-2 py-1 text-[10px] text-[#3B3B3B]" data-id="element-411">
                  160 lbs → <strong className="text-tealslate" data-id="element-412">112–160g</strong>
                  /day
                </span>
                <span className="bg-tealslate/20 px-2 py-1 text-[10px] text-[#3B3B3B]" data-id="element-413">
                  200 lbs → <strong className="text-tealslate" data-id="element-414">140–200g</strong>
                  /day
                </span>
              </div>
            </div>
          </div>
          <div data-id="element-415">
            <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-4 mb-6" data-id="element-416">
              <h3 className="text-[10px] font-bold text-tealslate uppercase tracking-wider mb-2" data-id="element-417">
                Non-Gym Goers / Beginners
              </h3>
              <p className="text-[#1F1F1F] font-bold text-sm mb-1" data-id="element-418">
                0.55g per pound of bodyweight per day
              </p>
              <div className="flex gap-2 mt-2" data-id="element-419">
                <span className="bg-white/60 px-2 py-1 text-[10px] text-[#3B3B3B]" data-id="element-420">
                  160 lbs → <strong className="text-tealslate" data-id="element-421">~88g</strong>/day
                </span>
                <span className="bg-white/60 px-2 py-1 text-[10px] text-[#3B3B3B]" data-id="element-422">
                  200 lbs → <strong className="text-tealslate" data-id="element-423">~110g</strong>
                  /day
                </span>
              </div>
            </div>
            <div className="border-l-4 border-tealslate pl-5" data-id="element-424">
              <h3 className="text-sm font-bold text-[#1F1F1F] mb-1" data-id="element-425">
                The 100g Target
              </h3>
              <p className="text-xs text-[#3B3B3B] leading-[1.8]" data-id="element-426">
                Aim for a minimum of 100 grams of protein per day. This is the
                baseline required to protect your muscle mass while in a caloric
                deficit.
              </p>
            </div>
          </div>
        </div>

        <div className="flex items-start gap-4 bg-[#EAEAE4] border-l-4 border-[#C4956A] px-5 py-4 mb-6" data-id="element-427">
          <AlertTriangle className="w-5 h-5 text-[#C4956A] shrink-0 mt-0.5" data-id="element-428" />
          <div data-id="element-429">
            <h3 className="font-bold text-[#1F1F1F] text-sm mb-1" data-id="element-430">
              Hair Loss Warning
            </h3>
            <p className="text-xs text-[#3B3B3B] leading-[1.8]" data-id="element-431">
              Hair loss occurs faster than muscle loss and is the earliest
              visible sign you are not getting enough protein. If you notice
              your hair falling out more than usual, you need more protein.
            </p>
          </div>
        </div>

        <SupplementCallout title="Protein Powder" description="If you struggle to hit your protein target through food alone, a whey or collagen protein supplement can bridge the gap. Look for 20-30g protein per serving with minimal added ingredients." data-id="element-432" />
      </div>
    </Page>;
}